// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header__aLgoS","Content":"styles_Content__vS5jS","Footer":"styles_Footer__YBbG8","Link":"styles_Link__viyhb","Table":"styles_Table__O-QMC"};